// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanTerminationPropertiesLiteDto } from './IPlanTerminationPropertiesLiteDto';
import {
    IPlanTerminationPropertiesLiteDtoFromJSON,
    IPlanTerminationPropertiesLiteDtoFromJSONTyped,
    IPlanTerminationPropertiesLiteDtoToJSON,
    IPlanTerminationPropertiesLiteDtoToJSONTyped,
} from './IPlanTerminationPropertiesLiteDto';
import type { IPlanYearDto } from './IPlanYearDto';
import {
    IPlanYearDtoFromJSON,
    IPlanYearDtoFromJSONTyped,
    IPlanYearDtoToJSON,
    IPlanYearDtoToJSONTyped,
} from './IPlanYearDto';

/**
 * 
 * @export
 * @interface IPlanTemplateConfigDto
 */
export interface IPlanTemplateConfigDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanTemplateConfigDto
     */
    id?: number;
    /**
     * 
     * @type {IPlanYearDto}
     * @memberof IPlanTemplateConfigDto
     */
    plan_year?: IPlanYearDto;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    name_state?: IPlanTemplateConfigDtoNameStateEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    account_type?: IPlanTemplateConfigDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    end_of_coverage_type?: IPlanTemplateConfigDtoEndOfCoverageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    account_type_state?: IPlanTemplateConfigDtoAccountTypeStateEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    plan_status?: IPlanTemplateConfigDtoPlanStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanTemplateConfigDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     */
    deletable?: boolean;
    /**
     * 
     * @type {IPlanTerminationPropertiesLiteDto}
     * @memberof IPlanTemplateConfigDto
     */
    termination_properties?: IPlanTerminationPropertiesLiteDto;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    funding_method_type?: IPlanTemplateConfigDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     */
    lu_gp_designation_allowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     */
    is_carded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     * @deprecated
     */
    is_replenished?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     */
    is_plan_level_funding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     */
    is_custom_prefund_calc?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     */
    allow_investments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    grace_period_type?: IPlanTemplateConfigDtoGracePeriodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    run_out_type?: IPlanTemplateConfigDtoRunOutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanTemplateConfigDto
     */
    is_rollover?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    max_rollover_amount_type?: IPlanTemplateConfigDtoMaxRolloverAmountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanTemplateConfigDto
     */
    max_rollover_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanTemplateConfigDto
     */
    rollover_claims_type?: IPlanTemplateConfigDtoRolloverClaimsTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanTemplateConfigDto
     */
    prefund_replenishment_percent?: number;
}

/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoNameStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoEndOfCoverageTypeEnum {
    DO_NOTHING = 'DO_NOTHING',
    DAY_OF_TERMINATION = 'DAY_OF_TERMINATION',
    FIRST_DAY_FOLLOWING_MONTH = 'FIRST_DAY_FOLLOWING_MONTH',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoAccountTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoGracePeriodTypeEnum {
    TWO_AND_HALF_MONTH = 'TWO_AND_HALF_MONTH',
    CUSTOM = 'CUSTOM',
    DOES_NOT_APPLY = 'DOES_NOT_APPLY'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoRunOutTypeEnum {
    LAST_DAY_OF_PLAN_YEAR = 'LAST_DAY_OF_PLAN_YEAR',
    CUSTOM = 'CUSTOM',
    NO_CLAIMS_DEADLINE = 'NO_CLAIMS_DEADLINE'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoMaxRolloverAmountTypeEnum {
    UNLIMITED = 'UNLIMITED',
    IRS_LIMIT = 'IRS_LIMIT',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IPlanTemplateConfigDtoRolloverClaimsTypeEnum {
    ALLOW_PRIOR_YEAR_CLAIMS = 'ALLOW_PRIOR_YEAR_CLAIMS'
}


/**
 * Check if a given object implements the IPlanTemplateConfigDto interface.
 */
export function instanceOfIPlanTemplateConfigDto(value: object): value is IPlanTemplateConfigDto {
    return true;
}

export function IPlanTemplateConfigDtoFromJSON(json: any): IPlanTemplateConfigDto {
    return IPlanTemplateConfigDtoFromJSONTyped(json, false);
}

export function IPlanTemplateConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanTemplateConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_year': json['plan_year'] == null ? undefined : IPlanYearDtoFromJSON(json['plan_year']),
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'name': json['name'] == null ? undefined : json['name'],
        'name_state': json['name_state'] == null ? undefined : json['name_state'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'end_of_coverage_type': json['end_of_coverage_type'] == null ? undefined : json['end_of_coverage_type'],
        'account_type_state': json['account_type_state'] == null ? undefined : json['account_type_state'],
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'termination_properties': json['termination_properties'] == null ? undefined : IPlanTerminationPropertiesLiteDtoFromJSON(json['termination_properties']),
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'lu_gp_designation_allowed': json['lu_gp_designation_allowed'] == null ? undefined : json['lu_gp_designation_allowed'],
        'is_carded': json['is_carded'] == null ? undefined : json['is_carded'],
        'is_replenished': json['is_replenished'] == null ? undefined : json['is_replenished'],
        'is_plan_level_funding': json['is_plan_level_funding'] == null ? undefined : json['is_plan_level_funding'],
        'is_custom_prefund_calc': json['is_custom_prefund_calc'] == null ? undefined : json['is_custom_prefund_calc'],
        'allow_investments': json['allow_investments'] == null ? undefined : json['allow_investments'],
        'grace_period_type': json['grace_period_type'] == null ? undefined : json['grace_period_type'],
        'run_out_type': json['run_out_type'] == null ? undefined : json['run_out_type'],
        'is_rollover': json['is_rollover'] == null ? undefined : json['is_rollover'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'max_rollover_amount_type': json['max_rollover_amount_type'] == null ? undefined : json['max_rollover_amount_type'],
        'max_rollover_amount': json['max_rollover_amount'] == null ? undefined : json['max_rollover_amount'],
        'rollover_claims_type': json['rollover_claims_type'] == null ? undefined : json['rollover_claims_type'],
        'prefund_replenishment_percent': json['prefund_replenishment_percent'] == null ? undefined : json['prefund_replenishment_percent'],
    };
}

export function IPlanTemplateConfigDtoToJSON(json: any): IPlanTemplateConfigDto {
    return IPlanTemplateConfigDtoToJSONTyped(json, false);
}

export function IPlanTemplateConfigDtoToJSONTyped(value?: IPlanTemplateConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_year': IPlanYearDtoToJSON(value['plan_year']),
        'plan_code': value['plan_code'],
        'name': value['name'],
        'name_state': value['name_state'],
        'account_type': value['account_type'],
        'end_of_coverage_type': value['end_of_coverage_type'],
        'account_type_state': value['account_type_state'],
        'plan_status': value['plan_status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'deletable': value['deletable'],
        'termination_properties': IPlanTerminationPropertiesLiteDtoToJSON(value['termination_properties']),
        'funding_method_type': value['funding_method_type'],
        'lu_gp_designation_allowed': value['lu_gp_designation_allowed'],
        'is_carded': value['is_carded'],
        'is_replenished': value['is_replenished'],
        'is_plan_level_funding': value['is_plan_level_funding'],
        'is_custom_prefund_calc': value['is_custom_prefund_calc'],
        'allow_investments': value['allow_investments'],
        'grace_period_type': value['grace_period_type'],
        'run_out_type': value['run_out_type'],
        'is_rollover': value['is_rollover'],
        'summary': value['summary'],
        'max_rollover_amount_type': value['max_rollover_amount_type'],
        'max_rollover_amount': value['max_rollover_amount'],
        'rollover_claims_type': value['rollover_claims_type'],
        'prefund_replenishment_percent': value['prefund_replenishment_percent'],
    };
}

